<div class="wallet-item-container container">
  <a
    class="back-btn text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center"
    [routerLink]="'/rewards/wallet'"
  >
    <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
  </a>

  <div class="d-block d-lg-none">
    <fgb-page-header [pageTitle]="'wallet.page.title'" [showQr]="false"></fgb-page-header>
  </div>

  <fgbcl-lottos-wallet-details [lottoId]="id"></fgbcl-lottos-wallet-details>
</div>
